import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import type { ControlledFieldProps, FormFieldBaseProps } from '../../types'
import styles from './Switch.module.scss'

type SwitchProps = FormFieldBaseProps & {
  placeholder?: string
  value?: boolean
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  (
    {
      error,
      fieldClassName,
      id,
      name,
      placeholder,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isRequired = false,
    },
    ref,
  ) => (
    <input
      className={cx(styles.switch, fieldClassName, {
        [styles.invalid]: Boolean(error),
      })}
      type="checkbox"
      checked={value}
      disabled={isDisabled}
      required={isRequired}
      {...{ id, name, placeholder, ref, onBlur, onChange }}
    />
  ),
)

type ControlledSwitchProps = ControlledFieldProps

export const ControlledSwitch = ({
  control,
  error,
  fieldClassName,
  id,
  name,
  isDisabled,
  isRequired,
}: ControlledSwitchProps) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Switch
        {...{
          error,
          fieldClassName,
          id,
          name,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
